import Checkbox, {
  CheckboxChangeHandler,
} from 'components/inputs/Checkbox/Checkbox';
import React, { useState } from 'react';
import { useTranslator } from '@bluebeam/react-i18n';

interface Props {
  id: string;
  text: string;
  checked: boolean;
  onChange: CheckboxChangeHandler;
  only: boolean;
  onOnly: Function;
}
const FilterItem: React.FC<Props> = (
  { only = false, onOnly = (): void => {} },
  props
) => {
  const [hovered, setHovered] = useState<boolean>(false);
  const { translate } = useTranslator(['filters']);
  const handleMouseOver = (): void => {
    setHovered(true);
  };

  const handleMouseOut = (): void => {
    setHovered(false);
  };

  const handleOnlyClick = (): void => {
    const { onOnly, text } = props;
    onOnly(text);
  };

  const { id, text, checked, onChange } = props;

  return (
    <div
      id={id}
      className="row justify-between items-center"
      style={{ height: '28px' }}
      onMouseOver={handleMouseOver}
      onMouseOut={handleMouseOut}
    >
      <div className="row items-center my1">
        <div className="mr2">
          <Checkbox
            id={`${id}-checkbox`}
            checked={checked}
            onChange={onChange}
          />
        </div>
        <span>{text}</span>
      </div>
      <button
        id={`${id}-only-btn`}
        style={{
          visibility: hovered && only ? 'visible' : 'hidden',
        }}
        className="btn-xs btn-link-primary h100 cursor-pointer flex-center"
        onClick={handleOnlyClick}
      >
        {translate('filters:only')}
      </button>
    </div>
  );
};

export default FilterItem;
